import MapMenu from '../lib/map_menu';
import UiInteraction from '../lib/ui_interaction';
import MapObject from '../models/map_object';

export default class ParkingLayer {
	constructor() {
		this.lots = [];
		this.markers = [];
		this.checkboxEl = document.getElementById('parking-layer');
		this.ignoreNextSetView = false;
		this.visible = false;
	}

	add(map) {
		let self = this;

		this.getData().then(() => {
			MapMenu.hide();

			// add marker for each lot
			this.lots.forEach((lot) => {
				const marker_el = document.createElement('div');
				marker_el.className = 'marker-parking';

				// override lake street lot number
				if (lot.properties.lot === '00001') {
					lot.properties.lot = '<b>P</b>';
				}

				let innerHTML =
					'<span class="lot-marker"></span><span class="available_parking"><span><span class="lot_number">Lot&nbsp;' +
					lot.properties.lot +
					'</span>';
				if (lot.properties.availability != null) {
					innerHTML =
						innerHTML +
						'<span class="spot-count" data-map_object_id="' +
						lot.properties.map_object_id +
						'">' +
						lot.properties.availability +
						'</span><span class="spots">spots</span></span></span>';
				}
				innerHTML = innerHTML + '</span > ';

				marker_el.innerHTML = innerHTML;

				const marker = new mapboxgl.Marker(marker_el, { anchor: 'bottom' })
					.setLngLat(lot.geometry.coordinates)
					.addTo(map);

				marker.getElement().setAttribute('aria-label', 'Lot ' + lot.properties.lot);
				marker.getElement().addEventListener('click', this.openPopup.bind(null, lot));

				this.markers.push(marker);
			});
			this.setBounds();
			this.visible = true;

			// start our timer again; update lot spots every 5 seconds
			if (W.lotInterval === undefined) {
				W.lotInterval = setInterval(function () {
					self.updateAllLots();
					// console.log('update all lots');
				}, 5000);
			}
		});
	}

	remove() {
		this.markers.forEach((marker) => marker.remove());
		clearInterval(W.lotInterval);
		W.lotInterval = undefined;
		this.visible = false;
	}

	// add popup and then stop marker click event propagation
	openPopup(lot, e) {
		UiInteraction.clearAllPopups();
		let map_object = new MapObject(lot.properties.map_object_id);
		UiInteraction.fetchAndAddFeature(map_object);
		e.stopPropagation();
	}

	async getData() {
		const url = W.api_root + 'parking';

		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Response status: ${response.status}`);
			}

			const json = await response.json();
			this.lots = json.features;
		} catch (error) {
			console.error(error.message);
		}
	}

	// TODO: Add to layter utils?
	setBounds() {
		// Bail if we're meant to ignore the first setView
		if (this.ignoreNextSetView) {
			this.ignoreNextSetView = false;
			return false;
		}

		let bounds = this.lots.reduce((bounds, feature) => {
			return bounds.extend(feature.geometry.coordinates);
		}, new mapboxgl.LngLatBounds());

		W.map.fitBounds(bounds, {
			maxZoom: 14,
			padding: 30, // in px, to make markers on the top edge visible
		});
	}

	updateAllLots() {
		const url = W.api_root + 'parking/spots';

		// get the live parking spots availability
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.json();
			})
			.then((lots) => {
				const updatedLots = [];
				lots.forEach(function (lot) {
					const lotEl = document.querySelector('[data-map_object_id="' + lot.map_object_id + '"]');
					if (lotEl && lot.spots !== lotEl.innerText) {
						lotEl.classList.add('hide');
						updatedLots.push({ el: lotEl, spots: lot.spots });
					}
				});

				// reveal updated spots numbers
				setTimeout(function () {
					updatedLots.forEach(function (lot) {
						lot.el.innerText = lot.spots;
						lot.el.classList.remove('hide');
					});
				}, 1000);
			});
	}
}
